module.exports = __webpack_public_path__ + "static/media/mb2q.3c70a813.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mb2q.png
// module id = 198
// module chunks = 0